import {
  ONE_MINUTE,
  ONE_HOUR,
  ONE_DAY,
  ONE_WEEK,
} from '@/pages/DocumentPage/constants'
import type { DocumentPage, FlattenedDocumentPage } from '@/lib/api/client'

type AnyDocumentPage = DocumentPage | FlattenedDocumentPage

/**
 * Returns true when an operation or sub-operation should be treated as hidden,
 * either because it has its own hidden flag set, or because any ancestor in the
 * chain is hidden.  Cascade is computed at render time; no extra fields are stored.
 */
export const isEffectivelyHidden = (
  op: AnyDocumentPage,
  allOps: AnyDocumentPage[],
): boolean => {
  if (op.template_values?.hidden === true) return true
  if (!op.parent) return false
  const parent = allOps.find((p) => p.id === op.parent)
  return parent ? isEffectivelyHidden(parent, allOps) : false
}

export const calculateTimeAgo = (time: Date) => {
  const timeDiff = Date.now() - time.getTime()
  let timeAgo

  if (timeDiff <= ONE_MINUTE) {
    timeAgo = 'Less than a minute ago'
  } else if (timeDiff <= ONE_HOUR) {
    timeAgo = `${Math.floor(timeDiff / ONE_MINUTE)} minute(s) ago`
  } else if (timeDiff <= ONE_DAY) {
    timeAgo = `${Math.floor(timeDiff / ONE_HOUR)} hour(s) ago`
  } else if (timeDiff <= ONE_WEEK) {
    timeAgo = `${Math.floor(timeDiff / ONE_DAY)} day(s) ago`
  } else {
    timeAgo = `${time.toLocaleDateString()}`
  }

  return timeAgo
}
